import { defineComponent as _defineComponent } from 'vue'
import { computed, Component } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StatsCard',
  props: {
    status: { default: '' },
    title: { default: '' },
    stats: { default: '' },
    statsComponent: null,
    statsClass: { default: 'stats-total ml-4' },
    mode: { default: 'disabled' },
    cardContainerClass: { default: '' },
    rightNote: { default: '' },
    containerMinWidth: { default: 'max-content' },
    containerMaxWidth: { default: '360px' },
    containerWidth: { default: '100%' },
    containerMaxHeight: { default: '' },
    containerMinHeight: { default: '' }
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as { status: string, title: string | number, stats: string | number, statsComponent?: Component, statsClass: string, mode: 'enabled' | 'disabled', cardContainerClass: string, rightNote: string, containerMinWidth: string | number, containerMaxWidth: string | number, containerWidth: string | number, containerMaxHeight: string | number, containerMinHeight: string | number };





const styles = computed(() => {
  const stylesObj: Record<string, any> = {};

  stylesObj['--container-min-width'] =
    typeof props.containerMinWidth === 'string'
      ? props.containerMinWidth
      : typeof props.containerMinWidth === 'number'
      ? `${props.containerMinWidth}px`
      : 'auto';

  stylesObj['--container-max-width'] =
    typeof props.containerMaxWidth === 'string'
      ? props.containerMaxWidth
      : typeof props.containerMaxWidth === 'number'
      ? `${props.containerMaxWidth}px`
      : 'auto';

  stylesObj['--container-width'] =
    typeof props.containerWidth === 'string'
      ? props.containerWidth
      : typeof props.containerWidth === 'number'
      ? `${props.containerWidth}px`
      : 'auto';

  stylesObj['--container-min-height'] =
    typeof props.containerMinHeight === 'string'
      ? props.containerMinHeight
      : typeof props.containerMinHeight === 'number'
      ? `${props.containerMinHeight}px`
      : 'auto';

  stylesObj['--container-max-height'] =
    typeof props.containerMaxHeight === 'string'
      ? props.containerMaxHeight
      : typeof props.containerMaxHeight === 'number'
      ? `${props.containerMaxHeight}px`
      : 'auto';

  return stylesObj;
});

return { __sfc: true,emit, props, styles }
}

})